{
  "StatvaluestypeLabel": "Saída para campos de porcentagem, data\/hora e duração:",
  "StatvaluestypeBothOptionLabel": "[Valores duplos (formatados + brutos)]",
  "StatvaluestypeMainOptionLabel": "Somente valor de exibição formatado (texto)",
  "StatvaluestypeAlternateOptionLabel": "Apenas valor bruto (para representação gráfica + uso de fórmula)",
  "CSVExportFormat_SectionHeader": "Formato de exportação CSV",
  "CSVExportFormat_SectionPara": "Você pode ajustar como os valores estatísticos de porcentagem, data\/hora e duração são gerados nos relatórios exportados para CSV.",
  "NAME": "CSVExportFormat"
}